import { Tabs } from "flowbite-react";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { MdAlignHorizontalLeft, MdOutlinePayments } from "react-icons/md";
import { FaMagnifyingGlass } from "react-icons/fa6";
import AdminPaymentsTable from "../components/tables/AdminPaymentsTable";
import AdminHistoryTable from "../components/tables/AdminHistoryTable";
import AdminCloseTable from "../components/tables/AdminCloseTable";

const ReportsPage = () => {
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className="bg-white px-4 py-4 rounded-md shadow-md relative">
        <Tabs
          aria-label="Default tabs"
          id="tab-company-details"
          activeTab={activeTab}
          onActiveTabChange={(tabIndex) => setActiveTab(tabIndex)}
        >
          <Tabs.Item title="Fechamento Financeiro" icon={MdAlignHorizontalLeft}>
            <AdminCloseTable isActive={activeTab === 0} />
          </Tabs.Item>
          <Tabs.Item title="Pagamentos" icon={MdOutlinePayments}>
            <AdminPaymentsTable isActive={activeTab === 1} />
          </Tabs.Item>
          <Tabs.Item title="Consultas" icon={FaMagnifyingGlass}>
            <AdminHistoryTable isActive={activeTab === 2} />
          </Tabs.Item>
        </Tabs>
      </div>
    </>
  );
};

export default ReportsPage;
